import { breakpoints } from '@bnnvara/breakpoints';
import { BaseButton } from '@bnnvara/buttons';
import styled from 'styled-components';

export const MenuButton = styled(BaseButton)`
  padding: 0;
  background: transparent;
  color: ${({ theme }) => theme.base.white};

  &:after {
    display: none;
  }

  svg {
    display: none;
  }

  ${breakpoints.md} {
    svg {
      display: block;
      width: 16px;
      height: 28px;
    }
  }
`;
